import {maps as gmaps} from 'google';

export const getFOVFromLatLngBounds = bounds => {
    if (!(bounds && bounds instanceof gmaps.LatLngBounds)) {
        throw new Error('A valid google maps LatLngBounds object is required for bounds.');
    }

    const boundsNE = bounds.getNorthEast();
    const boundsSW = bounds.getSouthWest();

    return {
        fov_min_lat: boundsNE.lat(),
        fov_min_lng: boundsNE.lng(),
        fov_max_lat: boundsSW.lat(),
        fov_max_lng: boundsSW.lng()
    };
};



// WEBPACK FOOTER //
// ./spothero/static/main/js/utils/google-maps.js